import { IFormDocument, ILink } from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

import { LinkUi } from './model';

/**
 * Get link ui data from BE metadata
 *
 * @param link
 * @param doc
 */
export function getLinkUi(link: ILink, doc: IFormDocument): LinkUi {
  const href = DocHelper.getStringValue(link.$name, doc);

  return {
    caption: DocHelper.getMessage(link.$name, doc),
    target: link.$target,
    internal: link.$internal === 'yes',
    newTab: link.$newtab === 'yes',
    sameTab: link.$sametab === 'yes',
    color: link.$color,
    href,
  };
}
